import { render, staticRenderFns } from "./policerank.vue?vue&type=template&id=70c16bea&scoped=true&"
import script from "./policerank.vue?vue&type=script&lang=js&"
export * from "./policerank.vue?vue&type=script&lang=js&"
import style0 from "./policerank.vue?vue&type=style&index=0&id=70c16bea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c16bea",
  null
  
)

export default component.exports